import { Image } from "expo-image";
import * as React from "react";
import { useTranslation } from "react-i18next";
import type { ImageStyle, StyleProp } from "react-native";

interface VehiLinkIconProps {
  size?: number;
  style?: StyleProp<ImageStyle>;
}

const VehiLinkIcon: React.FC<VehiLinkIconProps> = ({ size = 120, style }) => {
  const { t } = useTranslation();
  return (
    <Image
      source={require("../../assets/images/vehilink-outline-full-icon.webp")}
      style={[{ width: size, height: size }, style]}
      contentFit="contain"
      accessibilityLabel={t("VEHILINK_LOGO_ALT")}
    />
  );
};

export default VehiLinkIcon;
